import script from "./ClassPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassPicker.vue?vue&type=script&setup=true&lang=js"

import "./ClassPicker.vue?vue&type=style&index=0&id=1917466e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1917466e"]])

export default __exports__